export default "__VITE_ASSET__FUUF29yE__"